<template>
 <div class="footer">
      <div class="heading">
        <h2>Blogy</h2>
      </div>
      <div class="content">
        <div class="services">
          <h4>Services</h4>
          <p><a href="#">App developmen</a></p>
          <p><a href="#">Web development</a></p>
          <p><a href="#">DevOps</a></p>
          <p><a href="#">Web designing</a></p>
        </div>
        <div class="social-media">
          <h4>Social</h4>
          <p>
            <a href="#"
              ><i class="fab fa-linkedin"></i> Linkedin</a
            >
          </p>
          <p>
            <a href="#"
              ><i class="fab fa-twitter"></i> Twitter</a
            >
          </p>
          <p>
            <a href="https://github.com/Cyebukayire"
              ><i class="fab fa-github"></i> Github</a
            >
          </p>
          <p>
            <a href="#"
              ><i class="fab fa-instagram"></i> Instagram</a
            >
          </p>
        </div>
        <div class="links">
          <h4>Quick links</h4>
          <p><a href="#">Home</a></p>
          <p><a href="#">About</a></p>
          <p><router-link to="/postDetails">Blogs</router-link></p>
          <p><a href="#">Contact</a></p>
        </div>
        <div class="details">
          <h4 class="address">Address</h4>
          <p>
            Lorem ipsum dolor sit amet  <br />
            adipisicing elit.
          </p>
          <h4 class="mobile">Mobile</h4>
          <p><a href="#">+250792233445</a></p>
          <h4 class="mail">Email</h4>
          <p><a href="#">blogy@business.com</a></p>
        </div>
      </div>
      <footer>
        <hr />
        &copy; 2021 Blogy @ Vue Designs.
      </footer>
    </div>
</template>